import { ChangeEvent } from 'react';
import React from 'react';

interface ILandrateInputProps {
    value ?: number | null;
    name : string;
    onChange : (e : ChangeEvent<HTMLInputElement>) => void;
    onBlur : (e : React.FocusEvent) => void;
    disabled : boolean;
    currencySymbol ?: string;
}

const LandrateInput = (props : ILandrateInputProps) : React.ReactElement => {
    if (typeof props.value === 'undefined' || props.value == null) {
        return <div className='fdr flx1 empty'></div>;
    }

    return (
        <div className='fdr jcfs aic'>
            {props.currencySymbol && <span className='currency'>{props.currencySymbol}</span>}
            <input
                value={props.value}
                disabled={props.disabled}
                autoComplete='off'
                name={props.name}
                onChange={props.onChange}
                onBlur={props.onBlur}
                type='number'
                min='0'
                step='any'
                className={'tac'}
            />
        </div>
    );
};

export default LandrateInput;
